export const MIN_TRAINING_YEARS = 1
export const MAX_TRAINING_YEARS = 4
